import React, { Component } from "react";
import { Stage, Layer, Rect, Text, Group } from "react-konva";

// const BOX_WIDTH = 120;
// const BOX_HEIGHT = 80;
// const BOX_MARGIN = 10;
// const PADDING = 20;

// export class KenoPayoutBoxes extends Component {
//     renderPayoutBoxes = () => {
//         const { payouts } = this.props;

//         return payouts.map((payout, index) => {
//             const x = index * (BOX_WIDTH + BOX_MARGIN);

//             return (
//                 <React.Fragment key={index}>
//                     <Rect
//                         x={x}
//                         y={0}
//                         width={BOX_WIDTH}
//                         height={BOX_HEIGHT / 2}
//                         fill="#2f3e4f"
//                         cornerRadius={6}
//                     />

//                     <Text

//                         x={x}
//                         y={12}
//                         width={BOX_WIDTH}
//                         align="center"
//                         text={`${payout.toFixed(2)}x`}
//                         fontSize={20}
//                         fontStyle="bold"
//                         fill="#ffffff"
//                     />
//                     <Group
//                         key={index}

//                         onMouseEnter={(e) => {
//                             this.props.onHover(index);
//                             e.target.getStage().container().style.cursor = 'pointer';
//                         }}

//                         onMouseLeave={(e) => {
//                             this.props.onHover(null);
//                             e.target.getStage().container().style.cursor = 'default';
//                         }}
//                     >

//                         <Rect
//                             x={x}
//                             y={50}
//                             width={BOX_WIDTH}
//                             height={BOX_HEIGHT / 2}
//                             fill="#2f3e4f"
//                             cornerRadius={6}

//                             cursor={'pointer'}
//                         // onMouseEnter={() => this.props.onHover(index)}
//                         // onMouseLeave={() => this.props.onHover(null)}
//                         />
//                         <Rect
//                             x={x + 20}
//                             y={59}
//                             width={20}
//                             height={20}
//                             fill={this.props.highlightcount==index?"#00e701":"#b0b8c1"} // approximate fill based on your image
//                             // fill="#b0b8c1" // approximate fill based on your image
//                             cornerRadius={4} // adds rounded corners
//                             shadowBlur={2}
//                             cursor={'pointer'}

//                         // onMouseEnter={() => this.props.onHover(index)}
//                         // onMouseLeave={() => this.props.onHover(null)}

//                         />
//                         <Text
//                             x={x}
//                             y={62}
//                             width={BOX_WIDTH}
//                             align="center"
//                             text={`${index}x`}
//                             fontSize={20}
//                             fontStyle="bold"
//                             fill="#ffffff"
//                             cursor={'pointer'}
//                         // onMouseEnter={() => this.props.onHover(index)}
//                         // onMouseLeave={() => this.props.onHover(null)}
//                         />

//                     </Group>
//                 </React.Fragment>
//             );
//         });
//     };

//     render() {
//         const totalWidth = (BOX_WIDTH + BOX_MARGIN) * this.props.payouts.length - BOX_MARGIN;

//         return (
//             <Stage width={totalWidth + PADDING * 2} height={BOX_HEIGHT + 20}>
//                 <Layer x={PADDING} y={10}>
//                     {this.renderPayoutBoxes()}
//                 </Layer>
//             </Stage>
//         );
//     }
// }

// export default KenoPayoutBoxes;
export class KenoPayoutBoxes extends Component {
    static defaultProps = {
        boxWidth: 120,
        boxHeight: 80,
        boxMargin: 10,
        padding: 20,
    };

    renderPayoutBoxes = () => {
        const { payouts, boxWidth, boxHeight, boxMargin, highlightcount, onHover } = this.props;

        return payouts.map((payout, index) => {
            const x = index * (boxWidth + boxMargin);

            return (
                <React.Fragment key={index}>
                    <Rect
                        x={x}
                        y={0}
                        width={boxWidth}
                        height={boxHeight / 2}
                        fill="#1b1f3a"
                        cornerRadius={6}
                    />

                    <Text
                        x={x}
                        y={12}
                        width={boxWidth}
                        align="center"
                        text={`${payout.toFixed(2)}x`}
                        fontSize={20}
                        fontStyle="bold"
                        fill="#ffffff"
                    />
                    <Group
                        onMouseEnter={(e) => {
                            onHover(index);
                            e.target.getStage().container().style.cursor = 'pointer';
                        }}
                        onMouseLeave={(e) => {
                            onHover(null);
                            e.target.getStage().container().style.cursor = 'default';
                        }}
                        cursor="pointer"
                    >
                        <Rect
                            x={x}
                            y={50}
                            width={boxWidth}
                            height={boxHeight / 2}
                            fill="#1b1f3a"
                            cornerRadius={6}
                        />
                        <Rect
                            x={x + 20}
                            y={59}
                            width={20}
                            height={20}
                            fill={highlightcount === index ? "#00e701" : "#b0b8c1"}
                            cornerRadius={4}
                            shadowBlur={2}
                        />
                        <Text
                            x={x+10}
                            y={62}
                            width={boxWidth}
                            align="center"
                            text={`${index}x`}
                            fontSize={20}
                            fontStyle="bold"
                            fill="#ffffff"
                        />
                    </Group>
                </React.Fragment>
            );
        });
    };

    render() {
        const { payouts, boxWidth, boxMargin, padding, boxHeight } = this.props;
        const totalWidth = (boxWidth + boxMargin) * payouts.length - boxMargin;

        return (
            <Stage width={totalWidth + padding * 2} height={boxHeight + 20}>
                <Layer x={padding} y={10}>
                    {this.renderPayoutBoxes()}
                </Layer>
            </Stage>
        );
    }
}
export default KenoPayoutBoxes;